import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import getHomePageCategorySettings from './getHomePageCategorySettings.graphql';
import CategoryForm from '../../../components/SiteAdmin/CategoryForm/CategoryForm';
import Loader from '../../../components/Common/Loader/Loader';
import s from './EditTopFeature.css';


export class EditTopFeature extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { getHomePageCategorySettings: { getHomePageCategorySettings, loading } } = this.props;

        let initialValues = {};

        if (!loading && getHomePageCategorySettings) {
            initialValues = {
                id: getHomePageCategorySettings?.id,
                logo: getHomePageCategorySettings?.logo,
                banner: getHomePageCategorySettings?.banner
            }

            if (getHomePageCategorySettings?.dynamicHomePageCategorySettings?.length) {
                initialValues['title'] = getHomePageCategorySettings?.dynamicHomePageCategorySettings.map((item) => ({
                    language: item?.language,
                    title: item?.title,
                    description: item?.description
                }))
            }
        }
        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    <div className={s.container}>
                        <div className={s.paddingRoutesSection}>
                            {!loading && <CategoryForm initialValues={initialValues} />}
                        </div>
                    </div>
                </div>
            </Loader>
        )
    }
}

export default compose(
    withStyles(s),
    graphql(getHomePageCategorySettings, {
        name: 'getHomePageCategorySettings',
        options: (props) => ({
            variables: {
                id: props.id
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }))(EditTopFeature)
